import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { ButtonGroup, Card, CardContent, CardHeader, FormControl, FormHelperText, Grid, Icon, IconButton, Stack } from '@mui/material'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialBox from '../../../components/MaterialBox'
import MaterialInput from '../../../components/MaterialInput'
import MaterialSelect from '../../../components/MasterSelect'
import PercentIcon from "@mui/icons-material/Percent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MaterialButton from '../../../components/MaterialButton'
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate } from 'react-router-dom'
import { createTaskProgressMutation, deleteTaskProgressMutation, getAllTask, getSalesperson, getTaskProgressById, updateTaskProgressMutation } from '../GraphQl'
import request from 'graphql-request'
import BASEURL from '../../Utils/Baseurl'
import ConfirmationDialog from '../../../components/Dialog/ConfirmationDialog'
import StatusBar from '../StatusBar'
import { useLoading } from '../../../context/LodingContext'
import { useSuccess } from '../../../context/SucccessContext'
import { useError } from '../../../context/ErrorContext'
import { BsFillPersonBadgeFill } from 'react-icons/bs'

function AddTaskStatusMonitoring() {

  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);
  const userRole = localStorage.getItem("userRole");
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();
  
  const statusOptions = [
    { label: 'Waiting', value: 'waiting' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'Follow-Up', value: 'follow_up' },
    { label: 'Completed', value: 'completed' },
    { label: 'Overdue', value: 'overdue'}
  ];

  const [salesPersonOptions, setSalespersonOptions] = useState();
  const [ taskStatusData, setTaskStatusData ] = useState({
        taskTitle: "",
        salesperson: "",
        statusUpdate: "",
        workCompleted: "",
        hours: "",
        remainingTime: "",

        taskTitleStatus: "unchecked",
        salespersonStatus: "unchecked",
        statusUpdateStatus: "unchecked",
        workCompletedStatus: "unchecked",
        hoursStatus: "unchecked"
  });
  
  const [ titleOptions, setTitleOptions ] = useState();
  const [ taskId, setTaskId ] = useState();
  const [confirmationDialog, setConfirmationDialog] = useState({
      open: false,
      title: "",
      message: "",
      showCancel: true,
      customSection: null,
      onConfirm: () => {},
      onCancel: () => {},
  });
  
  const [togglePage, setTogglePage] = useState({
        view: false,
        edit: false,
  });

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  useEffect(() => {
      setTogglePage({
        ...togglePage,
        view: params?.search !== "" ? true : false,
      });
  }, []);

  useEffect(() => {
    fetchAllTask();
  },[]);

  useEffect(() => {
    if (id) {
      fetchTaskProgressById();
    }
  }, [id]);

  useEffect(() => {
    if(taskId){
      fetchTaskDataByTaskId();
    }
  },[taskId]);

  //Fetch Task Title
  const fetchAllTask = async() => {
    try{
      const response = await request(BASEURL, getAllTask);
      const data = response?.allTasks?.data;
      const options = data?.map((task) => ({
        label: task.title,
        value: task.id,
      }));
      setTitleOptions(options);
      
    }
    catch(error){
      console.error("Error Fetching Data", error);
    }
  }

  // Fetch Salesperson by Task ID
  const fetchTaskDataByTaskId = async () => {
    try{
      const response = await request(BASEURL, getSalesperson, { id: taskId});
      const data = response?.taskById?.data;
      
      const dataItem = data?.[0];
      const assignedTo = dataItem?.assignedTo;

      const sPOptions = [{
        label: assignedTo.username,
        value: assignedTo.id,
      }];
      setSalespersonOptions(sPOptions);
    }
    catch(error){
      console.error("Error Fetching Data",error);
    }
  }

  //Fetch By ID
  const fetchTaskProgressById = async () => {
    try{
      const response = await request(BASEURL, getTaskProgressById, {
        id: id,
      });
      const responseData = response?.progressUpdateById?.data?.[0];
      if (responseData) {
        setTaskStatusData({
          taskTitle: { label: responseData.task?.title, value: responseData.task?.id },
          salesperson: { label: responseData.task?.assignedTo?.username, value: responseData.task?.assignedTo?.id },
          statusUpdate: { label: responseData.status, value: responseData.status },
          workCompleted: responseData.workCompleted,
          hours: responseData.hoursWorked,
          remainingTime: responseData.remainingTime,
  
          taskTitleStatus: "success",
          salespersonStatus: "success",
          statusUpdateStatus: "success",
          workCompletedStatus: "success",
          hoursStatus: "success"
        });
      }
    }
    catch(error){
      console.error("Unable to fetch data", error);
    }
  }

  //Create Mutation
  const handleAddTaskProgressData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true)
        const values = {
          taskId: taskStatusData?.taskTitle?.value,
          assignedTo: taskStatusData?.salesperson?.value,
          status: taskStatusData?.statusUpdate?.value,
          workCompleted: taskStatusData?.workCompleted,
          hoursWorked: taskStatusData?.hours,
          isReviewed: false,
        };
        try{
          const response = await request(BASEURL, createTaskProgressMutation, {
            input: values
          });
          
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setSuccessStatus(true);
          setSucessTitle("Task Progress Created ");
          setTimeout(()=> {
            setSuccessStatus(false);
            navigate("/taskstatusmonitoring")
          },1000);
        }
        catch(error){
          console.error("Error Submitting Data", error);
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setErrorStatus(true);
          setErrormessage("Error Submitting Task Progress");

          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
        finally{
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  // Edit Mutation
  const handleEditTaskProgressData = async() => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to update your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        const value = {
          id: id,
          taskId: taskStatusData?.taskTitle?.value,
          assignedTo: taskStatusData?.salesperson?.value,
          status: taskStatusData?.statusUpdate?.value,
          workCompleted: parseFloat(taskStatusData?.workCompleted),
          hoursWorked: parseFloat(taskStatusData?.hours),
          isReviewed: true
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        try{
          const response = await request(BASEURL, updateTaskProgressMutation, {
            input: value
          });
          setSuccessStatus(true);
          setSucessTitle("Task Progress Updated ");
          setTimeout(() => {
              setSuccessStatus(false);
              navigate('/taskstatusmonitoring');
          },2000);

        }
        catch(error){
          console.error("Error Updating Data",error);
          setErrorStatus(true);
          setErrormessage("Sorry, couldn't Update Data")
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
      
        }
        finally{
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      }
    });
  };

  //Delete Mutation
    const handleDeleteTaskProgressData = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Delete your details?",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);
          try{
            const response = await request( BASEURL, deleteTaskProgressMutation, {
              id: id,
            });
            setSuccessStatus(true);
            setSucessTitle("Task Progress Deleted ");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/taskstatusmonitoring")
            },3000);
            
          }
          catch(error){
            console.error("Error Deleting Data",error);
            setErrorStatus(true);
            setErrormessage("Sorry, couldn't Delete Data")
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
          }
          finally{
            setCirleLoading(false);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    };

    const checkAllFields = () => {
      let allowSubmit = false;
      if(taskStatusData.taskTitleStatus === "success" &&
        taskStatusData.salespersonStatus === "success" &&
        taskStatusData.statusUpdateStatus === "success" &&
        taskStatusData.workCompletedStatus === "success" &&
        taskStatusData.hoursStatus === "success"
      )
      {
        allowSubmit = true;
      }
      else{
        allowSubmit = false;
      }
      return allowSubmit;
    }

    // Handle Change
  const handleTaskStatusChange = (event, selectEvent) => {
      let taskStatusState = { ...taskStatusData };
    
      if (event?.target === undefined && selectEvent) {
        switch (selectEvent.name) {
          case "taskTitle": {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
            if (alphaNLenghthRegex.test(event?.trim?.())) {
              taskStatusState[selectEvent.name + "Status"] = "success";
            } else {
              taskStatusState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }
            if (event?.value) {
              setTaskId(event.value);
            }
            taskStatusState.salesperson = null;
            taskStatusState.salespersonStatus = "unchecked";
            break;
          }

          case "salesperson": {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
            if (alphaNLenghthRegex.test(event?.trim?.())) {
              taskStatusState[selectEvent.name + "Status"] = "success";
            } else {
              taskStatusState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }
            break;
          }
          case "statusUpdate": {
            if (event?.value) {
              taskStatusState[selectEvent.name + "Status"] = "success";
            } else {
              taskStatusState[selectEvent.name + "Status"] = "error";
            }
            taskStatusState[selectEvent.name] = event;
            break;
          }
        }
        taskStatusState[selectEvent.name] = event;
      }
    
      else if (event && event.target) {

        switch (event.target.name) {
          case "workCompleted": {
            const value = event.target.value;
            const numericValue = value;
          
            if (value === "") {
              taskStatusState[event.target.name + "Status"] = "unchecked";
            } else {
              const isValid = !isNaN(numericValue) && numericValue >= 0 && numericValue <= 100;
              taskStatusState[event.target.name + "Status"] = isValid ? "success" : "error";
            }  
            taskStatusState[event.target.name] = value;
            break;
          }
           
          case "hours": {
            const value = event.target.value;
            const isValid = !isNaN(value) && value.trim() !== "";
            taskStatusState[event.target.name + "Status"] =
              value === "" ? "unchecked" : isValid ? "success" : "error";
            break;
          }    
        }

        taskStatusState[event.target.name] = event.target.value;
      }
      setTaskStatusData(taskStatusState);
  };

    // Handle Cancel
  const handleCancelTaskProgress = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure you want to Cancel your details?",
        showCancel: true,
        showConfirm: true,
        onConfirm: () => {
          handlecancel();
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
  const handlecancel = ()=>{
      navigate('/taskstatusmonitoring')
  }

    
  return (
    <DashboardLayout>
         {confirmationDialog.open && (
              <ConfirmationDialog
                open={confirmationDialog.open}
                title={confirmationDialog.title}
                message={confirmationDialog.message}
                showCancel={confirmationDialog.showCancel}
                showConfirm={confirmationDialog.showConfirm}
                customSection={confirmationDialog.customSection}
                onConfirm={confirmationDialog.onConfirm}
                onCancel={confirmationDialog.onCancel}
              />
            )}
        <Card>
        <Grid item xs={12}>
          <StatusBar status={taskStatusData.statusUpdate?.value} />
        </Grid>

            <CardHeader
                title={      
                  <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  >
                    <Stack direction="row" spacing={0}>
                        <IconButton
                          sx={{ mr: 1, mt: -0.7 }}
                          onClick={() => {
                            navigate("/taskstatusmonitoring");
                          }}
                        >
                          <ArrowBackIcon />
                        </IconButton>                  
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Task Progress Details
                        </MaterialTypography>
                    </Stack> 
                </Stack>
                }
                action={
                  <>
                {togglePage.edit || togglePage.view ? (         
                <ButtonGroup variant="outlined" aria-label="Loading button group" size="small">
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                    >
                    Edit
                    </MaterialButton>
                    <MaterialButton
                       variant="gradient"
                       color="dark"
                       onClick={handleDeleteTaskProgressData}
                       startIcon={<DeleteIcon />}
                     >
                       Delete
                     </MaterialButton>
                </ButtonGroup>
                ) : ''}
                </>
                }
            />

            <CardContent style={{ height: "50vh" }}>
               <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                                         <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                                         <MaterialTypography
                                                         sx={{color:'#460058',fontFamily:'Aptos'}}
                                                           component="label"
                                                           variant="body2"
                                                           fontWeight="700"
                                                         >
                                                           Task Progress Information
                                                         </MaterialTypography>
                                                       </Stack>
                <MaterialBox sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                    {/* Task Title */}
                    <Grid item xs={12} sm={6} md={4}>
                    <MaterialBox display="flex" flexDirection="column" gap={0.5}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Task Title
                        </MaterialTypography>
                        <MaterialSelect 
                        name="taskTitle"
                        options={titleOptions}
                        value={taskStatusData.taskTitle}
                        onChange={handleTaskStatusChange}
                        isDisabled={togglePage?.view === true ? true : false}
                        success={taskStatusData.taskTitleStatus === "success"}
                        error={taskStatusData.taskTitleStatus === "error"}
                        />
                        {taskStatusData.taskTitleStatus === "error" &&
                        taskStatusData.taskTitle && (
                          <FormControl error>
                            <FormHelperText>
                              Enter a valid Task Title
                            </FormHelperText>
                          </FormControl>
                        )}
                    </MaterialBox>
                    </Grid>

                    {/* Assigned Salesperson */}
                    <Grid item xs={12} sm={6} md={4}>
                    <MaterialBox display="flex" flexDirection="column" gap={0.5}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Assigned Salesperson
                        </MaterialTypography>
                        <MaterialSelect 
                        name="salesperson"
                        options={salesPersonOptions}
                        value={taskStatusData.salesperson}
                        onChange={handleTaskStatusChange}
                        isDisabled={togglePage?.view === true ? true : false}
                        success={taskStatusData.salespersonStatus === "success"}
                        error={taskStatusData.salespersonStatus === "error"}
                        />
                    </MaterialBox>
                    </Grid>

                    {/* Status Update */}
                    <Grid item xs={12} sm={6} md={4}>
                    <MaterialBox display="flex" flexDirection="column" gap={0.5}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Status Update
                        </MaterialTypography>
                        <MaterialSelect
                        name="statusUpdate"
                        options={statusOptions}
                        value={taskStatusData.statusUpdate}
                        onChange={handleTaskStatusChange}
                        isDisabled={togglePage?.view === true ? true : false}
                        success={taskStatusData.statusUpdateStatus === "success"}
                        error={taskStatusData.statusUpdateStatus === "error"}
                        />
                    </MaterialBox>
                    </Grid>

                    {/* Work Completed */}
                    <Grid item xs={12} sm={6} md={4}>
                    <MaterialBox display="flex" flexDirection="column" gap={0.5}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Work Completed
                        </MaterialTypography>
                        <MaterialInput 
                        name="workCompleted"
                        type="number"
                        value={taskStatusData.workCompleted}
                        onChange={handleTaskStatusChange}
                        disabled={togglePage?.view === true ? true : false}
                        success={taskStatusData.workCompletedStatus === "success"}
                        error={taskStatusData.workCompletedStatus === "error"}
                        icon={{
                            direction: "right",
                            component: (
                              <Icon color="action" fontSize="small">
                                <PercentIcon />
                              </Icon>
                            ),
                          }}
                        />
                         {taskStatusData.workCompletedStatus === "error" &&
                        taskStatusData.workCompleted && (
                          <FormControl error>
                            <FormHelperText>
                              Enter a value between 0 to 100
                            </FormHelperText>
                          </FormControl>
                        )}
                    </MaterialBox>
                    </Grid>

                    {/* Hours Worked */}
                    <Grid item xs={12} sm={6} md={4}>
                    <MaterialBox display="flex" flexDirection="column" gap={0.5}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Hours Worked
                        </MaterialTypography>
                        <MaterialInput 
                        name="hours"
                        type="number" 
                        value={taskStatusData.hours}
                        onChange={handleTaskStatusChange}
                        disabled={togglePage?.view === true ? true : false}
                        success={taskStatusData.hoursStatus === "success"}
                        error={taskStatusData.hoursStatus === "error"}
                         />
                    </MaterialBox>
                    </Grid>
                </Grid>
                </MaterialBox>
                {taskStatusData.remainingTime != "" && (    
                <MaterialBox sx={{ mt: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <MaterialBox display="flex" flexDirection="column" gap={0.5}>
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          color="error">
                          Remaining Time
                        </MaterialTypography>
                        <MaterialInput
                        value={taskStatusData.remainingTime}
                        disabled={true}
                        success={taskStatusData.remainingTime}
                        />
                      </MaterialBox>
                    </Grid>
                  </Grid>
                </MaterialBox>
                )}  

            </CardContent>
             <MaterialBox
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  {togglePage.edit && (
                    <>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={handleCancelTaskProgress}
                      >
                        Discard
                      </MaterialButton>
        
                      <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="dark"
                        // disabled={!checkFields()}
                        onClick={handleEditTaskProgressData}
                      >
                        Update
                      </MaterialButton>
                    </>
                  )}
        
                {!togglePage.view && !togglePage.edit && (
                    <>
                      <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="dark"
                        onClick={handleCancelTaskProgress}
                      >
                        Cancel
                      </MaterialButton>
                      <MaterialButton
                        sx={{ m: 4, marginLeft: "4px" }}
                        variant="gradient"
                        color="dark"
                        disabled={!checkAllFields()}
                        onClick={handleAddTaskProgressData}
                      >
                        Submit
                      </MaterialButton>
                    </>
                 )}
                </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default AddTaskStatusMonitoring